import { useQuery } from '@tanstack/react-query'
import { getShiftWork } from 'api/shift'
import { QueryFnParams } from 'queries/types'
import { shiftWorkKey } from './keys'

export function useShiftWork(params: QueryFnParams<typeof getShiftWork>[0]) {
  return useQuery({
    refetchInterval: 60000, // refresh every 60s, same as the shift detail query
    queryKey: shiftWorkKey(params.shiftId),
    queryFn: ({ signal }) => getShiftWork(params, signal),
  })
}
